import React, { createContext, useContext, useState, useEffect } from 'react';
import { AUTH_CONFIG } from '../config/auth.config';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check for existing session on mount
  useEffect(() => {
    const session = localStorage.getItem(AUTH_CONFIG.sessionKey);
    if (session) {
      try {
        const { timestamp } = JSON.parse(session);
        const now = Date.now();
        // Check if session is still valid
        if (now - timestamp < AUTH_CONFIG.sessionTimeout) {
          setIsAuthenticated(true);
        } else {
          // Session expired
          localStorage.removeItem(AUTH_CONFIG.sessionKey);
        }
      } catch {
        localStorage.removeItem(AUTH_CONFIG.sessionKey);
      }
    }
    setIsLoading(false);
  }, []);

  const login = (username, password) => {
    if (username === AUTH_CONFIG.username && password === AUTH_CONFIG.password) {
      const session = {
        timestamp: Date.now(),
        user: username,
      };
      localStorage.setItem(AUTH_CONFIG.sessionKey, JSON.stringify(session));
      setIsAuthenticated(true);
      return { success: true };
    }
    return { success: false, error: 'Invalid username or password' };
  };

  const logout = () => {
    localStorage.removeItem(AUTH_CONFIG.sessionKey);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
